<template>
  <div class="wap-activity-style">
    <div class="content-box">
      <div class="left-show">
        <Swiper
          class="left-activityStyle-img"
          :showData="showData.showImg"
          :showIndex="showData.id"
          :key="`swiper-wap-${showData.id}`"
        />
        <div class="left-activityStyle-title">
          <div class="style-title">
            {{ lan ? showData.activityEnTitle : showData.activityCnTitle }}
          </div>
          <div
            class="style-subTitle-time"
            v-if="showData.startDate"
          >
            {{ formatActivityDate(showData.startDate, showData.endDate) }}
          </div>
          <div class="style-subTitle">
            {{ lan ? showData.activityEnBrief : showData.activityCnBrief }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "./swiper.vue";

export default {
  name: "WapActivityStyle",
  components: {
    Swiper,
  },
  props: {
    showData: {
      type: Object,
      default: () => ({}),
    },
    showIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    "$store.state.isEn"(newVal) {
      this.lan = newVal;
    },
    showData: {
      handler() {
        // 监听showData变化，确保组件及时更新
      },
      deep: true
    }
  },
  methods: {
    // 格式化活动日期显示
    formatActivityDate(startDate, endDate) {
      // 如果没有结束日期或者开始日期和结束日期相同，则只显示开始日期
      if (!endDate || startDate === endDate) {
        return startDate || '';
      }
      // 否则显示日期范围格式
      return `${startDate || ''}-${endDate || ''}`;
    }
  },
};
</script>

<style scoped>
.wap-activity-style {
  width: 100%;
}

.content-box {
  width: 100%;
  margin: 40px auto 20px;
}

.left-show {
  height: auto;
  width: 90%;
  margin: 0 auto;
}

.left-activityStyle-title {
  width: 100%;
}

.left-activityStyle-img {
  width: 100%;
  height: auto;
}

.style-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  margin-top: 20px;
  text-align: left;
  font-weight: Bold;
}

.style-subTitle {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  line-height: 28px;
  font-weight: Regular;
  margin-top: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 11;
}

.style-subTitle-time {
  font-family: SourceHanSansCN-Regular;
  font-size: 12px;
  color: #98989f;
  letter-spacing: 0;
  text-align: left;
  margin-top: 10px;
  font-weight: 400;
}

/* 添加响应式优化 */
@media (min-width: 768px) {
  .style-title {
    font-size: 24px;
  }
  
  .style-subTitle {
    font-size: 16px;
    line-height: 32px;
  }
  
  .style-subTitle-time {
    font-size: 14px;
  }
}
</style>